export default __webpack_public_path__ + "static/media/empty_icon.593bf029.svg";